import {createApp} from 'vue'
import App from './App.vue'
import router from './router';
import i18n from './locales'
import vant from 'vant'
import 'vant/lib/index.css'
import http from './utils/axios'
import toast from './utils/toast'
import VConsole from 'vconsole'
import { initializeBrokerWebAuthorization, isBrokerWebAuthorization } from './utils/brokerWebAuthorization'
import './assets/css/brokerWebAuthorization.css'

// 这个库会在桌面端自动将mouse事件转换成对应的touch事件，使得组件能够在桌面端使用。
import '@vant/touch-emulator';
// 引入lib-flexible进行移动端适配
import 'lib-flexible/flexible';
import Vue3CountryIntl from 'vue3-country-intl'
import 'vue3-country-intl/lib/vue3-country-intl.css'

// 保留开发插件访问的应用实例，受限上下文就绪前不挂载页面。
const app = createApp(App)

// mountApplication 受限上下文就绪后启动原应用，兼容既有 legacy 构建目标。
const mountApplication = async () => {
  // 先接收 Web 登录态再挂载路由，保证普通 bridge、埋点及调试器不接触登录态。
  await initializeBrokerWebAuthorization()

  // 挂载到全局
  app.config.globalProperties.$http = http
  app.component(Vue3CountryIntl.name, Vue3CountryIntl)

  app.use(i18n)
  app.use(vant)
  app.use(toast)
  app.use(router)
  app.mount('#app')

  if (import.meta.env.DEV && !isBrokerWebAuthorization()) {
    const vConsole = new VConsole()
    app.config.globalProperties.$vConsole = vConsole
  }

}
mountApplication()
